import type {
  DatasetsMutatorItem,
  DatasetsMutatorItemData,
  DatasetsMutatorItemKey,
  DatasetsMutatorItemPayload,
  DatasetsMutatorMutationType,
  DatasetsMutatorRemoveItemProps,
  GetDatasetsMutatorItemKeyProps,
} from "./datasets-mutator.type";

/**
 * Builds unique key for each mutator item based on item props
 */
export const getDatasetsMutatorItemKey = ({
  datasetType,
  datasetId,
  uniqueKey,
}: GetDatasetsMutatorItemKeyProps): DatasetsMutatorItemKey => {
  if (datasetId) return `${datasetType}_${datasetId}`;
  if (uniqueKey) return `${datasetType}_${uniqueKey}`;
  return datasetType;
};

/**
 * Builds unique key for each mutator item based on item props or `mutationKey` if provided
 */
export const getDatasetsMutatorRemoveItemKey = (
  props: DatasetsMutatorRemoveItemProps
): DatasetsMutatorItemKey => {
  if ("mutationKey" in props) return props.mutationKey;
  return getDatasetsMutatorItemKey(props);
};

export const convertDatasetsMutatorItem = (
  item: DatasetsMutatorItemPayload
): DatasetsMutatorItemData => ({
  mutationType: item.mutationType,
  datasetType: item.datasetType,
  datasetId: "datasetId" in item ? item.datasetId : undefined,
  variables: "variables" in item ? item.variables : undefined,
  uniqueKey: "uniqueKey" in item ? item.uniqueKey : undefined,
});

export const isDatasetsMutatorItemType = <T extends DatasetsMutatorItem>(
  item: DatasetsMutatorItem,
  type: DatasetsMutatorMutationType
): item is T => {
  return item.mutationType === type;
};
